import script from "./ZakatDonate.vue?vue&type=script&setup=true&lang=js"
export * from "./ZakatDonate.vue?vue&type=script&setup=true&lang=js"

import "./ZakatDonate.vue?vue&type=style&index=0&id=d465bb38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d465bb38"]])

export default __exports__